

import React from 'react';
import {
  Box, Grid, Paper, Typography, IconButton, Chip, Button, useTheme, useMediaQuery
} from '@mui/material';

// Property CRM Icons
import GroupsIcon from '@mui/icons-material/Groups';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CampaignIcon from '@mui/icons-material/Campaign';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GridViewIcon from '@mui/icons-material/GridView';
import Whatshot from '@mui/icons-material/Whatshot';
import HighlightOff from '@mui/icons-material/HighlightOff';
import CRMLogo from '../assets/crmimg.png';
import { useNavigate } from 'react-router-dom';


function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

const Dashboard = () => {

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const greetText = getGreeting();

  const miniStats = [
    { icon: <GroupsIcon />, val: 1284, label: 'New Enqury', color: '#3147AA', bg: '#EEF2FF', path: '/dashboard/inquiry'},
    { icon: <PersonAddAlt1Icon />, val: 12, label: 'Enqury List', color: '#FF6B35', bg: '#FFF0EB', path: '/dashboard/inquiry-details' },
    { icon: <Whatshot />, val: 12, label: 'Hot Leads', color: '#FF6B35', bg: '#FFF0EB' },
    { icon: <HomeWorkIcon />, val: 94, label: 'Converted', color: '#9C27B0', bg: '#F3E5F5' },
    { icon: <HighlightOff/>, val: 5, label: 'No Answer', color: '#fd1212', bg: '#EAFDF9' },
    // { icon: <CampaignIcon />, val: 45, label: 'ACTIVE ADS', color: '#E91E63', bg: '#FCE4EC' },
    { icon: <AssignmentIcon />, val: 156, label: 'Analysis Report', color: '#3B6FE8', bg: '#EEF3FF' },
    { icon: <BarChartIcon />, val: '24.8%', label: 'Todays Work', color: '#4CAF50', bg: '#E8F5E9' },
    { icon: <MapsHomeWorkIcon />, val: 8, label: 'PROJECTS', color: '#FF9800', bg: '#FFF3E0' },
  ];

  const mainModules = [
    {
      title: 'Lead Management', desc: 'Track and convert property inquiries.',
      icon: <GroupsIcon />, color: '#3147AA',
      stats: [{ v: 1284, l: 'TOTAL', bg: '#EEF2FF' }, { v: 642, l: 'HOT', bg: '#EEFCF5' }, { v: 387, l: 'NEW', bg: '#FEF2F2' }]
    },
    {
      title: 'Site Visit Tracker', desc: 'Manage client visits and schedules.',
      icon: <LocationOnIcon />, color: '#FF6B35',
      stats: [{ v: 52, l: 'TOTAL', bg: '#FFF0EB' }, { v: 15, l: 'TODAY', bg: '#EEFCF5' }, { v: 37, l: 'PENDING', bg: '#FEF2F2' }]
    },
    {
      title: 'Project Listings', desc: 'Manage active infra projects.',
      icon: <MapsHomeWorkIcon />, color: '#9C27B0',
      stats: [{ v: 8, l: 'TOTAL', bg: '#F3E5F5' }, { v: 5, l: 'ACTIVE', bg: '#EEFCF5' }, { v: 3, l: 'UPCOMING', bg: '#F5F5F5' }]
    },
  ];

  return (
    <Box sx={{
      p: { xs: 1, md: 5 },
      bgcolor: '#F8FAFD',
      minHeight: '100vh',
      width: '100%',
      boxSizing: 'border-box',
      // सेंटरला आणण्यासाठी खालील ३ ओळी महत्त्वाच्या आहेत
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>

      {/* ── HEADER ── */}
      <Box sx={{
        mb: 4,
        px: { xs: 1, md: 0 },
        width: '100%',
        maxWidth: '1200px', // जास्त पसरू नये म्हणून मॅक्स विड्थ
        display: 'flex',
        justifyContent: 'center' // स्वतःला सेंटर मध्ये ठेवण्यासाठी
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          textAlign: 'left' 
        }}>
          <Box
            sx={{
              width: { xs: 80, md: 120 }, 
              height: 'auto', 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {/* तुमचा स्वतःचा लोगो इथे ॲड केला आहे */}
            <Box
              component="img"
              src={CRMLogo}
              alt="CRM Logo"
              sx={{
                width: '75%', // लोगो बॉक्सच्या आत किती मोठा हवा त्यानुसार (70-80% योग्य वाटतो)
                height: '75%',
                objectFit: 'contain' // लोगो स्ट्रेच होणार नाही याची काळजी घेते
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#7B90A8', letterSpacing: 1.5 }}>ADMIN PANEL</Typography>
              <Box sx={{ width: 7, height: 7, bgcolor: '#4CAF50', borderRadius: '50%' }} />
            </Box>
            <Typography variant={isMobile ? "h6" : "h4"} sx={{ fontWeight: 800, lineHeight: 1.2,color: '#060475' }}>{greetText}, Admin</Typography>
            <Typography sx={{ fontSize: 11, color: '#7B90A8' }}>Varadvinayak Real Infra Overview</Typography>
          </Box>
          <IconButton sx={{ border: '1px solid #E0E4EC', borderRadius: '10px' }}><RefreshIcon fontSize="small" /></IconButton>
        </Box>
      </Box>

      {/* ── MINI STATS (Grid gap fixed to prevent overlapping) ── */}
     {/* ── MINI STATS ── */}
<Grid container spacing={1} sx={{ mb: 5, width: '100%', m: 0 }}>
  {miniStats.map((s, i) => (
    <Grid item xs={6} sm={4} md={3} lg={1.5} key={i} sx={{ p: '4px !important' }}>
      <Paper 
        elevation={0} 
        onClick={() => s.path && navigate(s.path)} // ✅ क्लिक केल्यावर नेव्हिगेट होईल
        sx={{
          p: { xs: 1, md: 2 }, 
          borderRadius: '12px', 
          border: '1px solid #E0E4EC',
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          width: '100%', 
          height: '100%', 
          boxSizing: 'border-box',
          cursor: s.path ? 'pointer' : 'default', // ✅ कर्सर पॉइंटर दिसेल
          '&:hover': { bgcolor: '#f0f0f0' } // ✅ थोडा होव्हर इफेक्ट
        }}
      >
        <Box sx={{ width: 32, height: 32, bgcolor: s.bg, color: s.color, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {React.cloneElement(s.icon, { sx: { fontSize: 18 } })}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: { xs: 14, md: 18 }, fontWeight: 800, lineHeight: 1 }}>{s.val}</Typography>
          <Typography noWrap sx={{ fontSize: { xs: 7, md: 9 }, fontWeight: 700, color: '#7B90A8', mt: 0.5 }}>{s.label}</Typography>
        </Box>
      </Paper>
    </Grid>
  ))}
</Grid>




    </Box>
  );
};

export default Dashboard;